<template>
  <div>
    <div
      v-if="avatarFile"
      style="width:128px;"
    >
      <center>
        <v-btn
          small
          color="secondary"
          class="mb-2"
          @click="clearFile"
        >
          clear
        </v-btn>
        <v-img
          v-if="isError"
          max-height="128"
          max-width="128"
          contain
          :src="accountImage"
        ></v-img>
        <v-img
          v-else
          max-height="128"
          max-width="128"
          contain
          :src="avatarFile"
          @error="handleError"
        ></v-img>
      </center>
    </div>
    <div
      v-else
      style="width:320px;"
    >
      <div class="mb-2">
        <v-btn
          class="mr-2"
          small
          color="secondary"
          @click="triggerFile"
        >
          <v-icon>
            mdi-plus
          </v-icon>
        </v-btn>
        <v-btn
          small
          class="mr-2"
          color="secondary"
          @click="rotate"
        >
          <v-icon>
            mdi-refresh
          </v-icon>
        </v-btn>
        <v-btn
          class="mr-2"
          small
          color="secondary"
          @click="clearFile"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
        <v-btn
          small
          color="secondary"
          @click="confirmCrop"
        >
          <v-icon>
            mdi-check
          </v-icon>
        </v-btn>
      </div>
      <div style="width:256px;height: 256px;">
        <vueCropper
          ref="cropper"
          :img="base64Image"
          :output-size="option.size"
          :output-type="option.outputType"
          :info="true"
          :full="option.full"
          :can-move="option.canMove"
          :can-move-box="option.canMoveBox"
          :original="option.original"
          :auto-crop="option.autoCrop"
          :auto-crop-width="option.autoCropWidth"
          :auto-crop-height="option.autoCropHeight"
          :fixed="option.fixed"
          :high="option.high"
          :fixed-number="option.fixedNumber"
          :center-box="option.centerBox"
          :info-true="option.infoTrue"
          :fixed-box="option.fixedBox"
          :mode="option.mode"
          @realTime="handleRealTime"
        ></vueCropper>
      </div>
      <input
        ref="avatarFileRef"
        class="d-none"
        type="file"
        capture="environment"
        accept="image/*"
        @change="handleFileChange"
      />
    </div>
  </div>
</template>
<script setup>
import { ref, toRefs, watch, computed } from 'vue'
import { VueCropper } from 'vue-cropper'
import { fileToBase64 } from '@/utils/helper'

const isError = ref(false)

const avatarFile = ref(null)
const avatarFileRef = ref(null)

const accountImage = computed(() => require('@/assets/images/AsianAlliance/account-circle.png'))

function triggerFile() {
  // console.log('avatarFileRef.value', avatarFileRef.value)

  avatarFileRef.value.click()
}

const props = defineProps({
  value: {
    type: String,
    default: '',
  },
})
const { value } = toRefs(props)

watch(value, newvalue => {
  avatarFile.value = newvalue

  // prevent maintain previous photo
  if (newvalue === '') {
    base64Image.value = ''
  }
})

const cropper = ref(null)
const option = ref({
  img: '', // 裁剪图片的地址
  info: false, // 裁剪框的大小信息
  outputSize: 1, // 裁剪生成图片的质量
  outputType: 'jpeg', // 裁剪生成图片的格式
  canScale: false, // 图片是否允许滚轮缩放
  autoCrop: true, // 是否默认生成截图框
  autoCropWidth: 128, // 默认生成截图框宽度
  autoCropHeight: 128, // 默认生成截图框高度
  fixedBox: true, // 固定截图框大小 不允许改变
  fixed: true, // 是否开启截图框宽高固定比例
  fixedNumber: [1, 1], // 截图框的宽高比例
  full: true, // 是否输出原图比例的截图
  high: true, // 是否开启高清截图
  canMoveBox: false, // 截图框能否拖动
  original: true, // 上传图片按照原始比例渲染
  centerBox: true, // 截图框是否被限制在图片里面
  infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
  mode: 'cover', // 裁剪框的模式,
})

const base64Image = ref('')

function handleFileChange(files) {
  console.log('files', files)
  console.log('avatarFile', avatarFile)
  console.log('avatarFileRef', avatarFileRef)
  if (avatarFileRef.value.files && avatarFileRef.value.files.length > 0) {
    fileToBase64(avatarFileRef.value.files[0]).then(result => {
      console.log('result', result)
      base64Image.value = result
    })
  }
}
function clearFile() {
//   avatarFileRef.value.files.length = 0
  base64Image.value = ''
  avatarFile.value = ''

  isError.value = false

  // cropper.value.clearCrop()
}

const emit = defineEmits('input')

function confirmCrop() {
  cropper.value.getCropData(data => {
  // do something
    avatarFile.value = data

    console.log(data)
    emit('input', data)
  })
}
function rotate() {
  if (base64Image.value && cropper.value) {
    cropper.value.rotateRight()
  }
}

function handleError(e) {
  console.log(e)
  isError.value = true

  // avatarFile.value = ''
  // emit('input', '')
}

function handleRealTime(data) {
  console.log(data)
}
</script>
